import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as Actions from '../../firebase-redux/actions/index.js'
import CustomInputAutocomplete from '../customInputAutocomplete/CustomInputAutocomplete'

const theme = {
    container: {
        position: 'relative',
        width: '100%',
    },
    suggestionsList: {
        margin: 0,
        padding: 0,
        listStyleType: 'none',
        position: 'absolute',
        width: '100%',
        maxHeight: '300px',
        border: '1px solid #7b7b7b',
        background: '#fff',
        borderRadius: '4px',
        fontFamily: 'Karla, Arial, Helvetica, sans-serif',
        overflowY: 'auto',
    },
    suggestion: {
        cursor: 'pointer',
        padding: '10px 20px',
    },
    suggestionHighlighted: {
        backgroundColor: '#d7df22',
    },
}

class MainSearch extends Component {
    constructor(props) {
        super(props)
        this.state = {
            value: '',
            suggestions: [],
            places: [],
        }

        this.clearMainSearch = this.clearMainSearch.bind(this)
    }

    onChange = (event, { newValue }) => {
        this.setState({
            value: newValue,
        })
    }

    clickEnter = event => {
        if (event.key === 'Enter') {
            if (this.state.suggestions.length > 0) {
                this.setState(
                    {
                        value: this.state.suggestions[0].city,
                    },
                    () => {
                        this.props.loadCoworkings({ city: this.state.value })
                    }
                )
            } else {
                this.setState({ value: '' })
                this.props.loadCoworkings()
            }
        }
    }

    clearMainSearch() {
        this.setState(
            {
                value: '',
            },
            () => {
                this.props.loadCoworkings()
            }
        )
    }

    onSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            suggestions: this.getSuggestions(value),
        })
    }

    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: [],
        })
    }

    getSuggestions = value => {
        let places = []
        this.props.coworkings.forEach(item => {
            if (!places.includes({ city: item.city }))
                places.push({ city: item.city })
        })

        const inputValue = value.trim().toLowerCase()
        const inputLength = inputValue.length

        return inputLength === 0
            ? []
            : places.filter(place => {
                  return place.city.toLowerCase().includes(inputValue)
              })
    }

    onSuggestionSelected = (event, { suggestion, suggestionValue }) => {
        this.props.loadCoworkings({ city: suggestionValue })
    }

    render() {
        return (
            <CustomInputAutocomplete
                onEnter={this.props.loadCoworkings}
                iterKey='city'
                value={this.props.value}
                iterable={this.props.coworkings}
                theme={theme}
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Actions, dispatch)
}

export default withTranslation()(
    connect(state => {
        return {
            coworkings: state.coworking.list,
            value: state.coworking.activeFilters.city,
        }
    }, mapDispatchToProps)(MainSearch)
)
